import React from 'react';
import { MainRouter } from './MainRouter';
import { Provider } from 'react-redux';
import 'shepherd.js/dist/css/shepherd.css';

/**
 * PARENT COMPONENT OF APPLICATION
 * @param {{store: import('redux').Store}} props
 * @returns {JSX.Element}
 */
function App({ store }) {
  return (
    <div>
      <Provider store={store}>
        <MainRouter />
      </Provider>
    </div>
  );
}

export default App;
